<template>
  <vx-card title="De quién fue el tiempo">
    <p class="gw-bajada">
      Distribución del tiempo total de tus procesos según el responsable de
      cada tramo. El tiempo se atribuye a quien debía actuar en ese momento.
    </p>

    <apexcharts
      v-if="hayDatos"
      type="bar"
      height="300"
      :options="opciones"
      :series="series"
    />
    <p v-else class="gw-sin-datos">No hay tramos de tiempo medidos en este periodo.</p>

    <p v-if="hayExcluidos" class="gw-nota">
      {{ tiempoLegible(minutosExcluidos) }} del total corresponden a esperas
      excluidas del cómputo del acuerdo de niveles de servicio.
    </p>
  </vx-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import slaFormat from "../../mixins/slaFormat";

export default {
  name: "SlaTimeByOwner",
  mixins: [slaFormat],
  components: { apexcharts: VueApexCharts },
  props: {
    reparto: { type: Object, default: () => ({}) },
  },

  computed: {
    filas() {
      return Object.keys(this.reparto)
        .map((code) => ({
          code: code,
          etiqueta: this.etiquetaResponsable(code),
          color: this.colorResponsable(code),
          minutos: this.reparto[code].minutos,
          excluidos: this.reparto[code].excluidos,
          porcentaje: this.reparto[code].porcentaje,
        }))
        .sort((a, b) => b.minutos - a.minutos);
    },

    hayDatos() {
      return this.filas.length > 0 && this.filas.some((f) => f.minutos > 0);
    },

    minutosExcluidos() {
      return this.filas.reduce((acc, f) => acc + (f.excluidos || 0), 0);
    },

    hayExcluidos() {
      return this.minutosExcluidos > 0;
    },

    unidad() {
      return this.unidadPara(this.filas.map((f) => f.minutos));
    },

    series() {
      return [
        {
          name: "Tiempo",
          data: this.filas.map((f) => this.enUnidad(f.minutos, this.unidad)),
        },
      ];
    },

    opciones() {
      const filas = this.filas;
      const unidad = this.unidad;
      return {
        chart: { type: "bar", toolbar: { show: false } },
        plotOptions: {
          bar: { horizontal: true, distributed: true, barHeight: "60%" },
        },
        colors: filas.map((f) => f.color),
        legend: { show: false },
        dataLabels: {
          enabled: true,
          formatter: (v, ctx) => filas[ctx.dataPointIndex].porcentaje + "%",
          style: { fontSize: "11px", colors: ["#fff"] },
        },
        grid: { borderColor: "#eee" },
        xaxis: {
          categories: filas.map((f) => f.etiqueta),
          title: {
            text: unidad.sufijo,
            style: { color: this.GW_GRIS_SUAVE, fontSize: "11px", fontWeight: 400 },
          },
          labels: { style: { colors: this.GW_GRIS_SUAVE, fontSize: "11px" } },
        },
        yaxis: {
          labels: {
            style: { colors: this.GW_GRIS, fontSize: "12px" },
            // Por defecto ApexCharts corta en 160px y deja "Verificación aca…".
            maxWidth: 220,
          },
        },
        tooltip: {
          y: {
            formatter: (v, ctx) =>
              v + " " + unidad.sufijo +
              " (" + filas[ctx.dataPointIndex].porcentaje + "% del total)",
          },
        },
      };
    },
  },
};
</script>

<style scoped>
.gw-bajada {
  font-size: 12px;
  color: #9a9a9a;
  margin: -6px 0 14px;
  max-width: 62ch;
}
.gw-sin-datos,
.gw-nota {
  font-size: 12px;
  color: #9a9a9a;
}
.gw-nota {
  margin: 10px 0 0;
}
</style>
